import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)<TextFieldProps>(
  ({ theme }) => ({
    '& .MuiInputBase-root': {
      fontSize: '0.875rem',
      backgroundColor: theme.palette.background.paper,
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    },
    '& .MuiInputBase-input': {
      padding: '8px 12px',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderWidth: '1px',
        borderColor: theme.palette.divider,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.text.secondary,
      },
      '&.Mui-focused fieldset': {
        borderWidth: '1px',
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
      },
      '&.Mui-error fieldset': {
        borderColor: theme.palette.error.main,
      },
      '&.Mui-disabled': {
        backgroundColor: 'transparent',
        '& fieldset': {
          borderColor: theme.palette.divider,
          opacity: 0.4,
        },
        '& .MuiInputBase-input': {
          color: theme.palette.text.primary,
          opacity: 1,
          WebkitTextFillColor: theme.palette.text.primary,
        },
        '& .MuiInputAdornment-root': {
          opacity: 1,
        },
        '& .MuiInputAdornment-root .MuiIconButton-root': {
          opacity: 1,
        },
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.875rem',
      transform: 'translate(12px, 9px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
      '&.Mui-disabled': {
        color: theme.palette.text.primary,
        opacity: 1,
      },
    },
    '& .MuiOutlinedInput-root.Mui-disabled + .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      opacity: 1,
    },
    '& .MuiFormHelperText-root': {
      fontSize: '0.75rem',
      marginTop: '4px',
      marginLeft: '2px',
    },
  }),
);

export interface BaseInputProps {
  label?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
}
